import thunkMiddleware from 'redux-thunk';

import analyticsMiddleware from './analytics';
import {fullStoryMiddleware} from './fullstory';
import launchSequenceMiddleware from './launchSequence';
import networkOffline from './networkOffline';

export default () => [
  // network middleware should go before all items
  // so let's put it as first item;
  // see more in documentation:
  // https://github.com/rgommezz/react-native-offline#usage-3
  networkOffline,

  thunkMiddleware,
  ...launchSequenceMiddleware,
  ...analyticsMiddleware,
  ...fullStoryMiddleware,
];
